import React, { useState, useEffect } from "react";
import * as ProductApi from "@src/api/ProductApi";
import { Link } from "react-router-dom";

interface ProductBreadcrumbsProps {
  productId: string;
}

interface ProductBreadcrumb {
  id: string;
  label: string;
}

export default function ProductBreadcrumbs({
  productId,
}: ProductBreadcrumbsProps) {
  const [isLoadingProductBreadcrumbs, setIsLoadingProductBreadcrumbs] =
    useState<boolean>(false);
  const [productBreadcrumbs, setProductBreadcrumbs] = useState<
    ProductBreadcrumb[]
  >([]);

  useEffect(() => {
    handleLoadProductBreadcrumbs();
  }, [productId]);

  const handleLoadProductBreadcrumbs = async () => {
    setIsLoadingProductBreadcrumbs(true);
    try {
      const response = await ProductApi.getProductBreadcrumbs(productId);
      setProductBreadcrumbs(response.body);
    } catch (e) {
      console.error(e);
    } finally {
      setIsLoadingProductBreadcrumbs(false);
    }
  };

  return (
    <div className="flex-row spaced-content text-default text-xs font-weight-regular">
      {isLoadingProductBreadcrumbs
        ? "Loading..."
        : productBreadcrumbs.map((productBreadcrumb, index) => (
            <React.Fragment
              key={`product-breadcrumb-${index}-${productBreadcrumb.id}`}
            >
              {!!productBreadcrumb.id ? (
                <Link
                  className="text-default"
                  to={`/product-category/${productBreadcrumb.id}/`}
                  data-testid={`product-breadcrumb-link-${productBreadcrumb.id}`}
                >
                  {productBreadcrumb.label}
                </Link>
              ) : (
                <span className="text-default">{productBreadcrumb.label}</span>
              )}

              {index < productBreadcrumbs.length - 1 && <span>/</span>}
            </React.Fragment>
          ))}
    </div>
  );
}
